import cl from 'classnames';
import React from 'react';

import ColumnDividerBoxItem, { ColumnDividerBoxItemProps } from './item/ColumnDividerBoxItem';

import './ColumnDividerBox.scss';

interface ColumnDividerBoxProps extends React.HTMLAttributes<HTMLDivElement> {}

interface ColumnDividerBoxComponent {
    Item: React.FC<ColumnDividerBoxItemProps>;
}

const ColumnDividerBox: React.FC<ColumnDividerBoxProps> & ColumnDividerBoxComponent = ({
    className,
    children,
    ...rest
}): React.JSX.Element => (
    <div {...rest} className={cl('kortbetjening-column-divider-box', className)}>
        {children}
    </div>
);

ColumnDividerBox.Item = ColumnDividerBoxItem;

export default ColumnDividerBox;
